package com.xtream.data_kmp.remote


import com.xtream.data_kmp.dto.Account
import com.xtream.data_kmp.dto.Ad
import com.xtream.data_kmp.dto.LiveCategory
import com.xtream.data_kmp.dto.LiveStream
import com.xtream.data_kmp.dto.SeriesCategory
import com.xtream.data_kmp.dto.SeriesStream
import com.xtream.data_kmp.dto.VodCategory
import com.xtream.data_kmp.dto.VodStream
import io.ktor.client.statement.HttpResponse
import kotlinx.serialization.ExperimentalSerializationApi
import kotlinx.serialization.json.Json

interface ApiService {
    suspend fun login(): HttpResponse
    suspend fun activate(data: String): HttpResponse
    suspend fun userLogin(): Account?
    suspend fun activationLogin(data: String): Account?
    suspend fun getLiveStreams(): List<LiveStream>?
    suspend fun getVodStreams(): List<VodStream>?
    suspend fun getSeriesStreams(): List<SeriesStream>?
    suspend fun getLiveCategories(): List<LiveCategory>?
    suspend fun getVodCategories(): List<VodCategory>?
    suspend fun getSeriesCategories(): List<SeriesCategory>?
    suspend fun getVodInfo(vodId: Int): HttpResponse
    suspend fun getSeriesInfo(streamId: Int): HttpResponse
    suspend fun getServerConfigs(): HttpResponse
    suspend fun getTmdbMovieLogo(tmdbKey: String): HttpResponse
    suspend fun tmdbTrendingMovies(tmdbKey: String): HttpResponse
    suspend fun tmdbTrendingTvShows(tmdbKey: String): HttpResponse
    suspend fun getSubtitle(tmdbId: String?, apiKey: String?, appPackageId: String?): HttpResponse
    suspend fun getSponsorBanner(): Ad
    suspend fun getBanner(bannerType: String?): Ad

    // ----------------------------------------------------
    // PLAYER
    // ----------------------------------------------------

    suspend fun getPlaylists(
        macAddress: String,
        apiKey: String

    ): HttpResponse

    suspend fun checkStatus(
        macAddress: String,
        apiKey: String

    ): HttpResponse

    suspend fun registerDevice(
        macAddress: String,
        deviceKey: String,
        deviceName: String,
        model: String,
        modelVersion: String,
        appVersion: String,
        apiKey: String

    ): HttpResponse

    suspend fun editPlaylist(playlistId: String, apiKey: String, body: Map<String, Any>): HttpResponse
    suspend fun deletePlaylist(playlistId: String, apiKey: String): HttpResponse

    companion object {
        @OptIn(ExperimentalSerializationApi::class)
        val jsonObj = Json {
            ignoreUnknownKeys = true
            isLenient = true
            encodeDefaults = false
            explicitNulls = false
        }
    }
}